module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sand_clock-57e602713c2cafcb4f32b353d0429d0b.png";